import { STATUS_BADGES, StatusBadge } from "@/shared/components/StatusBadge";
import { TriggerDispatchStatus } from "@/shared/domain/triggers";

const STATUS_TITLES: Record<TriggerDispatchStatus, string> = {
  [TriggerDispatchStatus.Claimed]:
    "The trigger claimed this dispatch and the target is about to run.",
  [TriggerDispatchStatus.Dispatched]: "The target ran.",
  [TriggerDispatchStatus.Failed]:
    "The target raised; a redelivered platform event may retry it.",
  [TriggerDispatchStatus.Shadow]:
    "Recorded by the retired shadow evaluation of legacy triggers; nothing ever ran.",
  [TriggerDispatchStatus.Unknown]:
    "The outcome could not be determined; flagged for operational review.",
};

interface DispatchStatusChipProps {
  status: TriggerDispatchStatus;
  /** Extra detail (e.g. the error a failed target raised), shown in the tooltip. */
  detail?: string | null;
}

export function DispatchStatusChip({
  status,
  detail,
}: DispatchStatusChipProps) {
  const title = detail
    ? `${STATUS_TITLES[status]} ${detail}`
    : STATUS_TITLES[status];
  return (
    <StatusBadge
      status={STATUS_BADGES.triggerDispatch[status]}
      tooltip={title}
      data-testid={`dispatch-status-${status}`}
    />
  );
}
